// DLC Chatbot API Configuration
// Update these values with your actual API endpoint
export const API_CONFIG = {
  baseURL: process.env.REACT_APP_API_BASE_URL || 'https://server1.abudlc-edu.ng:8000',
  timeout: process.env.REACT_APP_API_TIMEOUT || 30000,
  headers: {
    'Content-Type': 'application/json',
  },
};

// For production, update this to your actual API endpoint
// Example: 'https://your-app.fly.dev'
export const CHATBOT_API_URL = 'https://server1.abudlc-edu.ng:8000';
